import React, { useState, useEffect, useCallback } from 'react';
import apiService from '../services/api.service';
import './Dashboardhome.css';

// Icons Components
const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  </svg>
);

const SalesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18"></path>
    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
  </svg>
);

const TrendingUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
    <polyline points="16 7 22 7 22 13"></polyline>
  </svg>
);

const ShoppingCartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  </svg>
);

const DollarSignIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10"></polyline>
    <polyline points="1 20 1 14 7 14"></polyline>
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const FilterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
  </svg>
);

const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const MoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </svg>
);

// Tab Component
const DashboardTab = ({ id, label, icon, isActive, onClick }) => (
  <button 
    className={`dashboard-tab ${isActive ? 'active' : ''}`}
    onClick={() => onClick(id)}
  >
    {icon}
    <span>{label}</span>
  </button>
);

// Stat Card Component
const StatCard = ({ icon, title, value, subtitle, trend, trendType, color, loading, onClick }) => {
  return (
    <div className={`stat-card ${color} ${loading ? 'loading' : ''}`} onClick={onClick}>
      <div className="stat-header">
        <div className="stat-icon">{icon}</div>
        <div className="stat-menu">
          <MoreIcon />
        </div>
      </div>
      <div className="stat-content">
        <h3 className="stat-title">{title}</h3>
        <div className="stat-value">{loading ? '---' : value}</div>
        {subtitle && <p className="stat-subtitle">{subtitle}</p>}
        {trend !== undefined && (
          <div className={`stat-change ${trendType}`}>
            <TrendingUpIcon />
            <span>{loading ? '-%' : `${trend >= 0 ? '+' : ''}${trend}%`}</span>
            <span className="period">önceki döneme göre</span>
          </div>
        )}
      </div>
    </div>
  );
};

// Chart Component
const WeeklyTrendChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="chart-container loading">
        <div className="chart-loading">
          <div className="loading-spinner"></div>
          <span>Veriler yükleniyor...</span>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-no-data">Veri bulunamadı</div>
      </div>
    );
  }

  const maxValue = Math.max(...data.map(item => item.sales));

  return (
    <div className="chart-container">
      <div className="chart">
        {data.map((item, index) => (
          <div key={index} className="chart-bar">
            <div 
              className="bar" 
              style={{ 
                height: maxValue > 0 ? `${(item.sales / maxValue) * 120}px` : '0px'
              }}
              title={`${item.label}: ${item.sales?.toLocaleString('tr-TR') || 0} ₺`}
            ></div>
            <span className="bar-label">{item.label}</span>
            <span className="bar-value">{(item.sales || 0).toLocaleString('tr-TR')} ₺</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Top Products Component
const TopProductsList = ({ products, loading, period, onPeriodChange }) => {
  if (loading) {
    return (
      <div className="top-products loading">
        <div className="loading-spinner small"></div>
        <span>Veriler yükleniyor...</span>
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="top-products">
        <div className="no-data">Bu dönem için satış verisi yok</div>
      </div>
    );
  }

  return (
    <div className="top-products">
      <div className="period-selector">
        <button 
          className={period === 'today' ? 'active' : ''} 
          onClick={() => onPeriodChange('today')}
        >
          Bugün
        </button>
        <button 
          className={period === 'week' ? 'active' : ''} 
          onClick={() => onPeriodChange('week')}
        >
          Hafta
        </button>
        <button 
          className={period === 'month' ? 'active' : ''} 
          onClick={() => onPeriodChange('month')}
        >
          Ay
        </button>
      </div>
      <div className="products-list">
        {products.slice(0, 8).map((product, index) => (
          <div key={index} className="product-item">
            <div className="product-rank">#{index + 1}</div>
            <div className="product-info">
              <h5>{product.name}</h5>
              <p>{product.category}</p>
            </div>
            <div className="product-stats">
              <span className="quantity">{product.quantity} adet</span>
              <span className="revenue">{product.revenue?.toLocaleString('tr-TR') || 0} ₺</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Recent Reports Component
const RecentReports = ({ reports, loading, onRefresh, onViewAll }) => {
  if (loading) {
    return (
      <div className="recent-reports loading">
        <div className="loading-spinner small"></div>
        <span>Veriler yükleniyor...</span>
      </div>
    );
  }

  return (
    <div className="recent-reports">
      <div className="reports-list">
        {reports?.slice(0, 6).map((report, index) => (
          <div key={report.id || index} className="report-item">
            <div className="report-icon">
              <SalesIcon />
            </div>
            <div className="report-content">
              <div className="report-header">
                <h5>{report.reportType === 'periodic' ? 'Periyodik' : 'Günlük'} Rapor</h5>
                <span className="report-time">{report.date} {report.time}</span>
              </div>
              <div className="report-stats">
                <span>{report.totalSales?.toLocaleString('tr-TR') || 0} ₺</span>
                <span>{report.totalItems} ürün</span>
              </div>
              {report.topItems && report.topItems.length > 0 && (
                <div className="top-items">
                  <span>En çok: {report.topItems[0]?.name} ({report.topItems[0]?.quantity})</span>
                </div>
              )}
            </div>
          </div>
        ))}
        {(!reports || reports.length === 0) && (
          <div className="no-reports">Henüz rapor bulunamadı</div>
        )}
      </div>
      <div className="reports-actions">
        <button className="refresh-btn" onClick={onRefresh} disabled={loading}>
          <RefreshIcon />
          Yenile
        </button>
        <button className="view-all-btn" onClick={onViewAll}>
          Tümünü Gör
        </button>
      </div>
    </div>
  );
};

// Analytics Component
const SalesAnalytics = ({ analytics, loading, period, onPeriodChange }) => {
  if (loading) {
    return (
      <div className="sales-analytics loading">
        <div className="loading-spinner small"></div>
        <span>Analitik veriler yükleniyor...</span>
      </div>
    );
  }

  if (!analytics) {
    return (
      <div className="sales-analytics">
        <div className="no-data">Analitik veri bulunamadı</div>
      </div>
    );
  }

  return (
    <div className="sales-analytics">
      <div className="analytics-header">
        <div className="period-selector">
          <button 
            className={period === 'today' ? 'active' : ''} 
            onClick={() => onPeriodChange('today')}
          >
            Bugün
          </button>
          <button 
            className={period === 'week' ? 'active' : ''} 
            onClick={() => onPeriodChange('week')}
          >
            Hafta
          </button>
          <button 
            className={period === 'month' ? 'active' : ''} 
            onClick={() => onPeriodChange('month')}
          >
            Ay
          </button>
        </div>
      </div>

      {/* Category Analytics */}
      <div className="category-analytics">
        <h4>Kategori Analizi</h4>
        <div className="categories-grid">
          {analytics.categories?.slice(0, 6).map((category, index) => (
            <div key={index} className="category-item">
              <div className="category-info">
                <h5>{category.name}</h5>
                <div className="category-stats">
                  <span>{category.totalQuantity} adet</span>
                  <span>{category.totalRevenue?.toLocaleString('tr-TR') || 0} ₺</span>
                </div>
              </div>
              <div className="category-progress">
                <div 
                  className="progress-bar" 
                  style={{ 
                    width: `${(category.totalRevenue / analytics.categories[0]?.totalRevenue * 100) || 0}%` 
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hourly Pattern */}
      {analytics.hourlyPattern && analytics.hourlyPattern.length > 0 && (
        <div className="hourly-analytics">
          <h4>Saatlik Satış Dağılımı</h4>
          <div className="hourly-chart">
            {analytics.hourlyPattern.map((hour, index) => (
              <div key={index} className="hour-bar">
                <div 
                  className="hour-value" 
                  style={{ 
                    height: `${(hour.sales / Math.max(...analytics.hourlyPattern.map(h => h.sales)) * 60) || 0}px` 
                  }}
                  title={`${hour.hour}:00 - ${hour.sales?.toLocaleString('tr-TR') || 0} ₺`}
                ></div>
                <span className="hour-label">{hour.hour}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// Quick Actions Component
const QuickActions = ({ onAction }) => {
  const actions = [
    { id: 'new-report', label: 'Yeni Rapor', icon: <ChartIcon />, color: 'blue' },
    { id: 'view-reports', label: 'Raporları Gör', icon: <SalesIcon />, color: 'green' },
    { id: 'analytics', label: 'Analitikler', icon: <TrendingUpIcon />, color: 'purple' },
    { id: 'export', label: 'Dışa Aktar', icon: <DownloadIcon />, color: 'orange' },
  ];

  return (
    <div className="quick-actions">
      <div className="actions-grid">
        {actions.map((action) => (
          <button 
            key={action.id} 
            className={`action-btn ${action.color}`}
            onClick={() => onAction(action.id)}
          >
            <div className="action-icon">{action.icon}</div>
            <span>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

// Main Dashboard Home Component
const DashboardHome = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  
  // Data states
  const [salesSummary, setSalesSummary] = useState(null);
  const [weeklyTrend, setWeeklyTrend] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [recentReports, setRecentReports] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  
  // Filter states
  const [topProductsPeriod, setTopProductsPeriod] = useState('today');
  const [analyticsPeriod, setAnalyticsPeriod] = useState('week');

  // Tab definitions
  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: <ChartIcon /> },
    { id: 'analytics', label: 'Detaylı Analitik', icon: <TrendingUpIcon /> },
    { id: 'reports', label: 'Rapor Yönetimi', icon: <SalesIcon /> }
  ];

  // Fetch functions
  const fetchSalesSummary = useCallback(async () => {
    try {
      const response = await apiService.getSalesTodaySummary();
      setSalesSummary(response.data);
    } catch (err) {
      console.error('Sales summary error:', err);
    }
  }, []);

  const fetchWeeklyTrend = useCallback(async () => {
    try {
      const response = await apiService.getSalesWeeklyTrend();
      setWeeklyTrend(response.data);
    } catch (err) {
      console.error('Weekly trend error:', err);
    }
  }, []);

  const fetchTopProducts = useCallback(async (period = topProductsPeriod) => {
    try {
      const response = await apiService.getSalesTopProducts({ period, limit: 10 });
      setTopProducts(response.data);
    } catch (err) {
      console.error('Top products error:', err);
    }
  }, [topProductsPeriod]);

  const fetchRecentReports = useCallback(async () => {
    try {
      const response = await apiService.getSalesRecentReports(10);
      setRecentReports(response.data);
    } catch (err) {
      console.error('Recent reports error:', err);
    }
  }, []);

  const fetchAnalytics = useCallback(async (period = analyticsPeriod) => {
    try {
      const response = await apiService.getSalesAnalytics(period);
      setAnalytics(response.data);
    } catch (err) {
      console.error('Analytics error:', err);
    }
  }, [analyticsPeriod]);

  // Main data fetch function
  const fetchAllData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      await Promise.all([
        fetchSalesSummary(),
        fetchWeeklyTrend(),
        fetchTopProducts(),
        fetchRecentReports(),
        fetchAnalytics()
      ]);

      setLastUpdate(new Date());
    } catch (err) {
      console.error('Dashboard data fetch error:', err);
      setError('Dashboard verileri yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  }, [fetchSalesSummary, fetchWeeklyTrend, fetchTopProducts, fetchRecentReports, fetchAnalytics]);

  // Effects
  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  useEffect(() => {
    fetchTopProducts(topProductsPeriod);
  }, [topProductsPeriod, fetchTopProducts]);

  useEffect(() => {
    fetchAnalytics(analyticsPeriod);
  }, [analyticsPeriod, fetchAnalytics]);

  // Auto-refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(fetchAllData, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchAllData]);

  // Event handlers
  const handleRefresh = () => {
    fetchAllData();
  };

  const handleTopProductsPeriodChange = (period) => {
    setTopProductsPeriod(period);
  };

  const handleAnalyticsPeriodChange = (period) => {
    setAnalyticsPeriod(period);
  };

  const handleQuickAction = (actionId) => {
    switch (actionId) {
      case 'new-report':
        // Handle new report action
        console.log('New report clicked');
        break;
      case 'view-reports':
        setActiveTab('reports');
        break;
      case 'analytics':
        setActiveTab('analytics');
        break;
      case 'export':
        // Handle export action
        console.log('Export clicked');
        break;
      default:
        break;
    }
  };

  const handleViewAllReports = () => {
    setActiveTab('reports');
  };

  // Render functions
  const renderOverviewTab = () => (
    <div className="overview-content">
      {/* Stats Row */}
      <div className="stats-row">
        <StatCard 
          icon={<DollarSignIcon />}
          title="Bugünkü Satış"
          value={salesSummary?.totalSales?.toLocaleString('tr-TR') + ' ₺' || '0 ₺'}
          trend={salesSummary?.salesTrend}
          trendType={salesSummary?.salesTrend >= 0 ? 'up' : 'down'}
          color="blue"
          loading={loading}
        />
        <StatCard 
          icon={<ShoppingCartIcon />}
          title="Satılan Ürün"
          value={salesSummary?.totalItems?.toString() || '0'}
          subtitle="adet"
          trend={salesSummary?.itemsTrend}
          trendType={salesSummary?.itemsTrend >= 0 ? 'up' : 'down'}
          color="green"
          loading={loading}
        />
        <StatCard 
          icon={<ClockIcon />}
          title="Ortalama Sipariş"
          value={salesSummary?.averageOrder?.toFixed(1) + ' ₺' || '0 ₺'}
          trend={salesSummary?.orderTrend}
          trendType={salesSummary?.orderTrend >= 0 ? 'up' : 'down'}
          color="orange"
          loading={loading}
        />
        <StatCard 
          icon={<ChartIcon />}
          title="Toplam Rapor"
          value={salesSummary?.reportsCount?.toString() || '0'}
          subtitle="bugün"
          color="purple"
          loading={loading}
        />
      </div>

      {/* Error Message */}
      {error && (
        <div className="error-banner">
          <p>{error}</p>
          <button onClick={handleRefresh}>Tekrar Dene</button>
        </div>
      )}

      {/* Last Update Info */}
      {lastUpdate && (
        <div className="last-update-info">
          <div className="update-time">
            <ClockIcon />
            <span>Son güncelleme: {lastUpdate.toLocaleTimeString('tr-TR')}</span>
          </div>
          <button className="refresh-btn" onClick={handleRefresh} disabled={loading}>
            <RefreshIcon />
            {loading ? 'Yenileniyor...' : 'Yenile'}
          </button>
        </div>
      )}
      
      {/* Main Dashboard Grid */}
      <div className="dashboard-grid">
        {/* Weekly Trend Chart */}
        <div className="dashboard-card chart-section">
          <div className="card-header">
            <h3>Haftalık Satış Trendi</h3>
            <div className="card-actions">
              <button className="action-btn" onClick={handleRefresh}>
                <RefreshIcon />
              </button>
            </div>
          </div>
          <div className="card-content">
            <WeeklyTrendChart data={weeklyTrend} loading={loading} />
          </div>
        </div>
        
        {/* Top Products */}
        <div className="dashboard-card products-section">
          <div className="card-header">
            <h3>En Çok Satan Ürünler</h3>
            <div className="card-actions">
              <button className="action-btn">
                <FilterIcon />
              </button>
            </div>
          </div>
          <div className="card-content">
            <TopProductsList 
              products={topProducts} 
              loading={loading}
              period={topProductsPeriod}
              onPeriodChange={handleTopProductsPeriodChange}
            />
          </div>
        </div>
        
        {/* Recent Reports */}
        <div className="dashboard-card reports-section">
          <div className="card-header">
            <h3>Son Raporlar</h3>
            <div className="card-actions">
              <button className="action-btn" onClick={handleViewAllReports}>
                Tümü
              </button>
            </div>
          </div>
          <div className="card-content">
            <RecentReports 
              reports={recentReports} 
              loading={loading}
              onRefresh={fetchRecentReports}
              onViewAll={handleViewAllReports}
            />
          </div>
        </div>

        {/* Quick Actions */}
        <div className="dashboard-card actions-section">
          <div className="card-header">
            <h3>Hızlı İşlemler</h3>
          </div>
          <div className="card-content">
            <QuickActions onAction={handleQuickAction} />
          </div>
        </div>
      </div>
    </div>
  );

  const renderAnalyticsTab = () => (
    <div className="analytics-content">
      <div className="analytics-header">
        <h2>Detaylı Satış Analitikleri</h2>
        <div className="analytics-actions">
          <button className="export-btn">
            <DownloadIcon />
            Dışa Aktar
          </button>
          <button className="refresh-btn" onClick={handleRefresh}>
            <RefreshIcon />
            Yenile
          </button>
        </div>
      </div>

      <div className="analytics-grid">
        <div className="dashboard-card analytics-main">
          <div className="card-header">
            <h3>Satış Analitikleri</h3>
          </div>
          <div className="card-content">
            <SalesAnalytics 
              analytics={analytics}
              loading={loading}
              period={analyticsPeriod}
              onPeriodChange={handleAnalyticsPeriodChange}
            />
          </div>
        </div>

        <div className="dashboard-card performance-metrics">
          <div className="card-header">
            <h3>Performans Metrikleri</h3>
          </div>
          <div className="card-content">
            <div className="metrics-grid">
              <div className="metric-item">
                <div className="metric-icon blue">
                  <DollarSignIcon />
                </div>
                <div className="metric-info">
                  <h4>Toplam Gelir</h4>
                  <p>{salesSummary?.totalSales?.toLocaleString('tr-TR') || 0} ₺</p>
                </div>
              </div>
              <div className="metric-item">
                <div className="metric-icon green">
                  <ShoppingCartIcon />
                </div>
                <div className="metric-info">
                  <h4>Toplam Satış</h4>
                  <p>{salesSummary?.totalItems || 0} adet</p>
                </div>
              </div>
              <div className="metric-item">
                <div className="metric-icon orange">
                  <ClockIcon />
                </div>
                <div className="metric-info">
                  <h4>Ortalama Sipariş</h4>
                  <p>{salesSummary?.averageOrder?.toFixed(1) || 0} ₺</p>
                </div>
              </div>
              <div className="metric-item">
                <div className="metric-icon purple">
                  <TrendingUpIcon />
                </div>
                <div className="metric-info">
                  <h4>Büyüme Oranı</h4>
                  <p>{salesSummary?.salesTrend?.toFixed(1) || 0}%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderReportsTab = () => (
    <div className="reports-content">
      <div className="reports-header">
        <h2>Rapor Yönetimi</h2>
        <div className="reports-actions">
          <button className="filter-btn">
            <FilterIcon />
            Filtrele
          </button>
          <button className="calendar-btn">
            <CalendarIcon />
            Tarih Seç
          </button>
          <button className="export-btn">
            <DownloadIcon />
            Dışa Aktar
          </button>
        </div>
      </div>

      <div className="reports-grid">
        <div className="dashboard-card reports-list-card">
          <div className="card-header">
            <h3>Son Raporlar</h3>
            <div className="card-actions">
              <button className="action-btn" onClick={fetchRecentReports}>
                <RefreshIcon />
              </button>
            </div>
          </div>
          <div className="card-content">
            <div className="reports-table">
              <div className="table-header">
                <div>Tarih</div>
                <div>Tür</div>
                <div>Toplam</div>
                <div>Ürün</div>
                <div>İşlem</div>
              </div>
              <div className="table-body">
                {recentReports?.map((report, index) => (
                  <div key={report.id || index} className="table-row">
                    <div>{report.date} {report.time}</div>
                    <div>
                      <span className="report-type">
                        {report.reportType === 'periodic' ? 'Periyodik' : 'Günlük'}
                      </span>
                    </div>
                    <div className="total-amount">
                      {report.totalSales?.toLocaleString('tr-TR') || 0} ₺
                    </div>
                    <div>{report.totalItems} adet</div>
                    <div className="table-actions">
                      <button className="view-btn">Görüntüle</button>
                      <button className="download-btn">
                        <DownloadIcon />
                      </button>
                    </div>
                  </div>
                ))}
                {(!recentReports || recentReports.length === 0) && (
                  <div className="no-data-row">Rapor bulunamadı</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-card reports-summary">
          <div className="card-header">
            <h3>Rapor Özeti</h3>
          </div>
          <div className="card-content">
            <div className="summary-stats">
              <div className="summary-item">
                <h4>Bugünkü Raporlar</h4>
                <span className="summary-value">
                  {salesSummary?.reportsCount || 0}
                </span>
              </div>
              <div className="summary-item">
                <h4>Haftalık Ortalama</h4>
                <span className="summary-value">
                  {weeklyTrend?.length ? Math.round(weeklyTrend.reduce((acc, day) => acc + day.sales, 0) / weeklyTrend.length).toLocaleString('tr-TR') : 0} ₺
                </span>
              </div>
              <div className="summary-item">
                <h4>En Yüksek Satış</h4>
                <span className="summary-value">
                  {weeklyTrend?.length ? Math.max(...weeklyTrend.map(d => d.sales)).toLocaleString('tr-TR') : 0} ₺
                </span>
              </div>
              <div className="summary-item">
                <h4>Trend</h4>
                <span className={`summary-value ${salesSummary?.salesTrend >= 0 ? 'positive' : 'negative'}`}>
                  {salesSummary?.salesTrend >= 0 ? '+' : ''}{salesSummary?.salesTrend?.toFixed(1) || 0}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'analytics':
        return renderAnalyticsTab();
      case 'reports':
        return renderReportsTab();
      case 'overview':
      default:
        return renderOverviewTab();
    }
  };

  return (
    <div className="dashboard-home">
      {/* Dashboard Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <h1 className="dashboard-title">Satış Dashboard'u</h1>
          <p className="dashboard-subtitle">
            Gerçek zamanlı satış verileri ve analitikler
          </p>
        </div>
        <div className="header-actions">
          <select className="period-selector">
            <option value="today">Bugün</option>
            <option value="week">Bu Hafta</option>
            <option value="month">Bu Ay</option>
          </select>
          <button className="header-btn" onClick={handleRefresh}>
            <RefreshIcon />
            Yenile
          </button>
          <button className="header-btn">
            <DownloadIcon />
            Dışa Aktar
          </button>
        </div>
      </div>

      {/* Dashboard Tabs */}
      <div className="dashboard-tabs">
        {tabs.map(tab => (
          <DashboardTab
            key={tab.id}
            id={tab.id}
            label={tab.label}
            icon={tab.icon}
            isActive={activeTab === tab.id}
            onClick={setActiveTab}
          />
        ))}
      </div>

      {/* Dashboard Content */}
      <div className="dashboard-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default DashboardHome;